import { render } from "./AccountRegistrationPrescriberDetail.vue?vue&type=template&id=ba171846"
import script from "./AccountRegistrationPrescriberDetail.vue?vue&type=script&lang=js"
export * from "./AccountRegistrationPrescriberDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__